import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EglenceBeyanAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "EglenceReklamBeyanlariListe";
        super(baseUrl);
    }

    getEglenceBeyanListe( sicilKodu:number, yili: number, aktifPasif: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        var request = new EglenceBeyanRequest( sicilKodu, yili, aktifPasif, mahalleKodu, caddeSokakKodu);
        return this.post("", request, false);
    }
}
export default new EglenceBeyanAPI();
class EglenceBeyanRequest {
    public sicilKodu?: number;
    public Yili: number;
    public AktifPasif: number;
    public mahalleKodu?: number;
    public caddeSokakKodu?: number;

    constructor( sicilKodu: number, yili: number, aktifPasif: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        this.sicilKodu = sicilKodu;
        this.Yili = yili;
        this.AktifPasif = aktifPasif;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
    }
}
export { EglenceBeyanRequest };